<template>
  <iAutoComplete
    show-caret
    :clear-value="''"
    v-bind="$attrs"
    :style-overrides="mergedStyleOverrides"
  >
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps ?? {}" />
    </template>
  </iAutoComplete>
</template>

<script>
const STUDIO_AUTOCOMPLETE_STYLE = Object.freeze({
  hoverItemBackgroundColor: "interactiveHover",
});

export default {
  name: "StudioAutoComplete",
  inheritAttrs: false,
  computed: {
    mergedStyleOverrides() {
      return { ...STUDIO_AUTOCOMPLETE_STYLE, ...this.$attrs["style-overrides"] ?? this.$attrs.styleOverrides ?? {} };
    },
  },
};
</script>
